import api from './api';

// Super admin session is stored under a SEPARATE key so it is never
// overwritten when a coaching admin / teacher / student logs in from
// another tab on the same origin.
const SA_KEY = 'eg_sa_token';
const UA_KEY = 'eg_token';

export async function login(coachingCode, username, password) {
  const { data } = await api.post('/auth/login', { coachingCode, username, password });
  const key = coachingCode === 'SUPERADMIN' ? SA_KEY : UA_KEY;
  localStorage.setItem(key, data.token);
  return data;
}

export function logout() {
  api.post('/auth/logout').catch(() => {});
  localStorage.removeItem(SA_KEY);
  localStorage.removeItem(UA_KEY);
}

export function getToken() {
  const isSA = typeof window !== 'undefined' && window.location.pathname.startsWith('/super-admin');
  return localStorage.getItem(isSA ? SA_KEY : UA_KEY) || null;
}

export function parseToken(token) {
  try {
    const base64 = token.split('.')[1];
    return JSON.parse(atob(base64));
  } catch {
    return null;
  }
}
